class LocalForage {
  constructor(key, instance) {
    this.key = key
    this.instance = instance
  }

  async getState() {
    return await this.instance.getItem(this.key)
  }

  async setState(value) {
    await this.instance.setItem(this.key, value)
  }

  async removeState() {
    await this.instance.removeItem(this.key)
  }
}

export default LocalForage
